export const fileTypes = {
    'feedback': 'fbf',
    'source'  : 'sf',
    'reference' : 'rf'
};
